import React, { useEffect, useState } from "react";
import "../style/news.css";
import { GetApi } from "../api/api-service";
import { API_Path, companyName, imgBaseUrl } from "../Const";
import { convertToSlug, onError } from "../components/CommonFun";
import NewsLoader from "../components/loader/NewsLoader";
import moment from "moment";
import { Link } from "react-router-dom";
import style from '../style/news.module.css';

export default function News() {
    const [allNews, setAllNews] = useState([]);
    const [isLoader, setIsLoader] = useState(true);
    useEffect(() => {
        fatchNewsAndArticles();
    }, []);
    const fatchNewsAndArticles = async () => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.fatchNewsAndArticles + "GetAll?pageNumber=1&pageSize=20");
            if (res && res.data.success) setAllNews(res.data.data);
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };
    const loaders = Array.from({ length: 8 });
    return (
        <div>
            <div className="page-section">
                <div className="container">
                    <div className="page-header">
                        <h1>News and Articles</h1>
                    </div>
                </div>
            </div>
            <div className={style.our_blog_box}>
                <div className="container">
                    {isLoader ? (
                        <div className="our-blog-inner">
                            <div className="our-blog-details">
                                {loaders.map((_, index) => (
                                    <NewsLoader />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="our-blog-inner">
                            <div className="our-blog-details">
                                {allNews
                                    .filter((type) => type.isActive)
                                    .map((item, i) => (
                                        <div className="our-project-card" key={i}>
                                            <div className="blog-card-img">
                                                <img src={imgBaseUrl + item?.filePath} alt={item.title} onError={onError} />
                                            </div>
                                            <div className="blog-info-data">
                                                <Link to={`/news/${convertToSlug(item.title)}-${item.id}`}>
                                                    <h3>{item.title}</h3>
                                                </Link>
                                                <div className={style.news_description}>
                                                    <p>{item.shortDescription}</p>
                                                </div>
                                                <Link to={`/news/${convertToSlug(item.title)}-${item.id}`} className={style.read_more}>
                                                    READ MORE
                                                </Link>
                                                <div className="news-date-time">
                                                    <div className="read-more-btn">By {companyName}</div>
                                                    <div className="blog-ftr-details">
                                                        <span>{moment(item.created, "DD-MM-YYYY hh:mm:ss A").format("DD MMM YYYY")}</span>
                                                        {/* <span>{formatDateToShortMonth(item.created)}</span> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
